import React, {useCallback} from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import {useToggleVisibility, useTranslation} from "@awe-web/shared/lib";
import {Button} from "./form.js";
import closeIcon from "./assets/close.svg";

import "./more_infos_button.scss";

const MORE_INFOS = "ALG0000036";

let closeLastOverlay = () => {};

export default function MoreInfosButton({className, heading, content}) {
  const {translate} = useTranslation();

  const {isComponentVisible, setComponentVisible} = useToggleVisibility();

  const handleButtonClick = useCallback(() => {
    if (isComponentVisible) {
      setComponentVisible(false);
      closeLastOverlay = () => {};
    }
    else {
      closeLastOverlay();
      closeLastOverlay = () => setComponentVisible(false);
      setComponentVisible(true);
    }
  }, [isComponentVisible, setComponentVisible]);
  const closeOverlay = useCallback(() => {
    setComponentVisible(false);
    closeLastOverlay = () => {};
  }, [setComponentVisible]);
  const preventEventBubbling = (event) => {
    event.preventDefault();
  };

  if (!heading || !content) {
    return null;
  }

  const combinedClassName = classnames("more-infos-button", className);

  return (
    <div className={combinedClassName} onClick={preventEventBubbling}>
      <Button
        quaternary
        onClick={handleButtonClick}
      >
        {translate(MORE_INFOS)}
      </Button>
      {isComponentVisible
        ? (
          <div className="more-infos-button__overlay">
            <div className="more-infos-button__overlay-title">
              {heading}
            </div>
            <div className="more-infos-button__overlay-content">
              {content}
            </div>
            <button className="more-infos-button__close-button" onClick={closeOverlay}>
              <img className="more-infos-button__close-icon" src={closeIcon} alt="Close" />
            </button>
          </div>
        )
        : null
      }
    </div>
  );
}

MoreInfosButton.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string,
  content: PropTypes.node
};
